export default function Spacer() {
  return <div style={{ flexGrow: 1 }} />;
}
